module.exports = __webpack_public_path__ + "static/media/icon-product-close.37b39da9.svg";